export function formatNumberWithMetricPrefix(number: number, lang = 'en') {
  /**
   * Intl.NumberFormat uses CLDR which does not support the Tsd. abbreviation by default
   * https://st.unicode.org/cldr-apps/v#/de/Compact_Decimal_Formatting/ff7ca46dee120b1
   * */
  if (lang === 'de' && number >= 1000 && number < 1000000) {
    return `${Math.trunc(number / 1000)} Tsd.`;
  }

  /**
   * Intl.NumberFormat uses CLDR which does not support the Tsd. abbreviation by default
   * https://st.unicode.org/cldr-apps/v#/it/Compact_Decimal_Formatting/ff7ca46dee120b1
   * */
  if (lang === 'it' && number >= 1000 && number < 1000000) {
    return `${Math.trunc(number / 1000)} MILA`;
  }

  if (lang === 'en' && number < 1000) {
    return number.toString();
  }

  if (number < 1000) {
    return new Intl.NumberFormat(lang).format(number);
  }

  // Add metric prefixes for values over 1000
  return new Intl.NumberFormat(lang, {
    notation: 'compact',
    maximumSignificantDigits: 3,
  })
    .format(number)
    .toUpperCase();
}

/**
 * Formats a number as USD with no fractional digits (e.g. $19, $45).
 * Uses en-US locale.
 */
export function formatUsd(value: number): string {
  return new Intl.NumberFormat('en-US', {
    currency: 'USD',
    style: 'currency',
    maximumFractionDigits: 0,
  }).format(value);
}

export function capitalise(word?: string) {
  if (!word) {
    return '';
  }
  return word.charAt(0).toUpperCase() + word.slice(1);
}

export function hasUpperCase(str: string) {
  return /[A-Z]/.test(str);
}

export function removeLineBreaks(s: string) {
  /**
   * \n -Unix-style line break
   * \r\n - Windows-style line break
   * \r -Old Mac-style line break
   */
  return s ? s.replace(/(\r\n|\n|\r)/gm, '') : s;
}

export function toSnakeCase(text: string) {
  return text
    .toLowerCase()
    .replaceAll(' ', '_')
    .replace(/[^a-z0-9_]/g, '');
}
